import * as React from "react";
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { UserAuthModel } from '../../models/user';
import AuthService from '../../services/authService';
import UserPersonalDataService from '../../services/userPersonalDataService';
import InteractionsService from '../../services/interactionsService';
import UserService from '../../services/userService';
import Growl from '../../common/components/alertMessage/growl';
import MedicinesList from './medicinesList';
import DiseasesList from './diseasesList';
import { MedicineForListModel } from "../../models";
import { DiseaseForGridModel } from "../../models";
import { InteractionsModel } from '../../models/interactions/interactionsModel';
import MedicineSearchDialog from './medicineSearchDialog';
import { Dropdown } from 'primereact/dropdown';
import { DropdownModel } from "../../models/dropdownModel";
import { enumToDropdownArray } from '../../common/functions/helperFunctions';
import { ProfessionType, PregnancyType } from "../../common/enums";
import { UserPersonalDataModel } from '../../models/user/userPersonalDataModel';
import InteractionsResultsComponent from './interactionsResultsComponent';
import Cookies from 'universal-cookie';
import { InteractionsResultModel } from '../../models/interactions/interactionsResultModel';
import { Accordion, AccordionTab } from 'primereact/accordion';
import Switch from '@material-ui/core/Switch';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faPills } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { Checkbox } from "@material-ui/core";

interface IProps {
  history: any,
  onUserLogout: any,
  lang: string
}

interface IState {
  error: any;
  isLoading: boolean;
  userAuth: UserAuthModel;
  mode: string;
  interactions: InteractionsModel;
  interactionsResult: InteractionsResultModel;
  isVisibleSearchMedicineDialog: boolean;
  searchDialogError: any;
  currentProfileUserId: number;
  userFamilyDropdown: Array<DropdownModel>;
  professionTypeDropdown: Array<DropdownModel>;
  pregnancyTypeDropdown: Array<DropdownModel>;
  isVisibleInteractionsResults: boolean;
  activeIndexOtherParams: any;
  isDriver: boolean;
  isMachineOperator: boolean;
}

class InteractionsComponent extends React.Component<IProps, IState> {

  authService = new AuthService();
  interactionsService = new InteractionsService(this.props.lang);
  userPersonalDataService = new UserPersonalDataService();
  userService = new UserService();
  growl: any;
  cookies = new Cookies();
  userId = this.authService.getUserId();
  userName = this.authService.getUserName();

  constructor(props: IProps) {
    super(props);

    const interactions = new InteractionsModel();
    interactions.medicines = new Array<MedicineForListModel>(0);
    interactions.userMedicines = new Array<MedicineForListModel>(0);
    interactions.userDiseases = new Array<DiseaseForGridModel>(0);

    const coikieMedicines = this.cookies.get('interactionsMedicines');
    if (coikieMedicines) {
      interactions.medicines = coikieMedicines;
    }

    const professionTypeDropdown: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];
    const pregnancyTypeDropdown: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];

    this.state = {
      error: null,
      isLoading: false,
      userAuth: this.authService.getUserAuth(),
      mode: 'interactionForm',
      interactions: interactions,
      interactionsResult: new InteractionsResultModel(),
      isVisibleSearchMedicineDialog: false,
      searchDialogError: null,
      currentProfileUserId: 0,
      userFamilyDropdown: new Array<DropdownModel>(),
      professionTypeDropdown: professionTypeDropdown.concat(enumToDropdownArray(ProfessionType, true)),
      pregnancyTypeDropdown: pregnancyTypeDropdown.concat(enumToDropdownArray(PregnancyType, true)),
      isVisibleInteractionsResults: false,
      activeIndexOtherParams: null,
      isDriver: false,
      isMachineOperator: false
    };
  }

  componentDidMount() {
    if (this.authService.isAuthenticated()) {
      this.setState({
        isLoading: true,
        currentProfileUserId: this.userId,
        userFamilyDropdown: [{ label: this.userName, value: this.userId }]
      });
      this.getUserFamily();
      this.getUserData(this.userId);
    }
  }

  getUserData(userId) {
    this.getUserMedicines(userId);
    this.getUserDiseases(userId);
    this.getUserProfile(userId);
  }

  handleProfileChange = (value) => {
    this.setState({
      currentProfileUserId: value
    })
    this.getUserData(value);
  }

  handleChange = (key, value) => {
    const interactions: InteractionsModel = this.state.interactions;
    interactions[key] = value;
    this.setState({ interactions: interactions });
  };

  getUserFamily() {
    this.userService.getUserFamilyDropdownList().then(
      (data: any) => {
        if (data) {
          this.setState({
            isLoading: false,
            userFamilyDropdown: this.state.userFamilyDropdown.concat(data)
          });
        }
      })
      .catch(error => {
        //this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  getUserMedicines(userId) {
    this.interactionsService.getUserMedicines(userId, this.props.lang).then(
      (data: any) => {
        if (data) {
          let interactions = this.state.interactions;
          interactions.userMedicines = data;
          this.setState({
            isLoading: false
          });
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  getUserDiseases(userId) {
    this.interactionsService.getUserDiseases(userId, this.props.lang).then(
      (data: any) => {
        if (data) {
          const interactions = this.state.interactions;
          interactions.userDiseases = data;
          this.setState({
            isLoading: false
          });
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  getUserProfile(userId) {
    this.userPersonalDataService.getUserPersonalData(userId).then(
      (data: UserPersonalDataModel) => {
        if (data) {
          let inter: InteractionsModel = { ...this.state.interactions };
          if (!inter) {
            inter = new InteractionsModel();
          }
          inter.drivingAndMachine = data.professionTypeId != null;
          inter.pregnancyAndBreastfeeding = data.pregnancyTypeId != null;
          this.setState({
            isLoading: false,
            interactions: { ...inter }
          });
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleAddClick = () => {
    this.setState({
      isVisibleSearchMedicineDialog: true,
    });
  }

  handleAddMedicineToList = (medicine: MedicineForListModel) => {
    let medicines = this.state.interactions.medicines;
    if (!medicines.some(m => m.medicineId == medicine.medicineId)) {
      medicines.push(medicine);
      const interactions = this.state.interactions;
      interactions.medicines = medicines;
      this.cookies.set('interactionsMedicines', medicines, { path: '/' });
      this.setState({
        isVisibleSearchMedicineDialog: false,
        interactions: interactions,
        searchDialogError: null,
        interactionsResult: new InteractionsResultModel(),
        isVisibleInteractionsResults: false
      });
    } else {
      this.setState({
        searchDialogError: { message: Translate('Selected medicine already exist in list.') }
      });
    }
  }

  handleRemoveMedicineClick = (e, medicineId) => {
    e.preventDefault();
    let medicines = this.state.interactions.medicines;
    let index = medicines.findIndex(m => m.medicineId == medicineId);
    medicines.splice(index, 1);
    const interactions = this.state.interactions;
    interactions.medicines = medicines;
    this.cookies.set('interactionsMedicines', medicines, { path: '/' });
    this.setState({
      interactions: interactions,
      interactionsResult: new InteractionsResultModel(),
      isVisibleInteractionsResults: false
    })
  }

  handleCancelSearchMedicine = () => {
    this.setState({
      isVisibleSearchMedicineDialog: false,
      searchDialogError: null
    });
  }

  clearDialogError = () => {
    this.setState({
      searchDialogError: null
    });
  }

  handleCheckInteractions = () => {
    this.setState({
      isLoading: true
    });

    const interactions = this.state.interactions;
    this.interactionsService.getMedicineInteractions(interactions, this.props.lang).then(
      (data: InteractionsResultModel) => {
        if (data) {
          this.setState({
            isLoading: false,
            isVisibleInteractionsResults: true,
            interactionsResult: data
          });
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleCancelClick = () => {
    this.setState({
      isVisibleInteractionsResults: false
    })
  }

  public render() {
    const {
      error, isLoading, interactions, interactionsResult, mode, isVisibleSearchMedicineDialog,
      searchDialogError, currentProfileUserId, userFamilyDropdown, professionTypeDropdown, pregnancyTypeDropdown,
      isVisibleInteractionsResults, activeIndexOtherParams, isDriver, isMachineOperator
    } = this.state;

    const interactionFormHtml =
      <div className="interactions-form clearfix">

        <div className="mt-10 mb-10">
          <div className="clearfix">
            <div style={{ float: 'left' }}>
              <label>{Translate('Medicines')} ({interactions.medicines.length}):</label>
            </div>
            <div style={{ float: 'right' }} className="mb-10">
              <Fab color="primary" size="small" aria-label="Add" onClick={this.handleAddClick}>
                <AddIcon />
              </Fab>
            </div>
          </div>
          {interactions.medicines.length > 0 ?
            <MedicinesList
              medicines={interactions.medicines}
              onRemoveClick={this.handleRemoveMedicineClick}
              withRemoveAction={true}
            /> : <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}><i>{Translate('Add medicine to check interactions.')}</i></span>}
        </div>

        {interactions.medicines.length > 0 ?
          <>

            {this.authService.isAuthenticated() ?
              <>
                {userFamilyDropdown.length > 1 ?
                  <div className="mb-10" style={{ maxWidth: '500px', textAlign: "left" }}>
                    <FormControl>
                      <InputLabel htmlFor="profile-label">{Translate('Profile')}</InputLabel>
                      <Select
                        value={currentProfileUserId}
                        onChange={(e) => this.handleProfileChange(e.target.value)}
                        inputProps={{
                          id: 'profile-label'
                        }}
                      >
                        {
                          userFamilyDropdown.map(m => <MenuItem key={m.value + 'Profile'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                        }
                      </Select>
                    </FormControl>
                  </div>
                  : null}
                <Accordion multiple={true}>
                  <AccordionTab header={(this.userId == currentProfileUserId ? Translate('My Medicines') : Translate('Medicines')) +
                    ' (' + interactions.userMedicines.length + ')'}>
                    <MedicinesList
                      medicines={interactions.userMedicines}
                      onRemoveClick={this.handleRemoveMedicineClick}
                      withRemoveAction={false}
                    />
                  </AccordionTab>
                  <AccordionTab header={(this.userId == currentProfileUserId ? Translate('My Diseases') : Translate('Diseases')) +
                    ' (' + interactions.userDiseases.length + ')'}>
                    <DiseasesList
                      diseases={interactions.userDiseases}
                    />
                  </AccordionTab>
                </Accordion>
              </> : null
            }

            <Accordion activeIndex={activeIndexOtherParams} onTabChange={(e) => this.setState({ activeIndexOtherParams: e.index })}>
              <AccordionTab header={Translate('Other parameters')}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <div className="mb-10" style={{ marginRight: 20 }}>
                    <Checkbox
                      name="drivingAndMachine"
                      onChange={(e) => this.handleChange("drivingAndMachine", e.target['checked'])}
                      checked={!!interactions.drivingAndMachine}
                      value={interactions.drivingAndMachine + ""}
                      color="primary"
                    />
                    <label style={{ padding: '10px 0 0 0px' }}>
                      {Translate('DrivingAndUsingMachines')}
                    </label>
                    {/* <FormControl>
                    <InputLabel htmlFor="profession-label">{Translate('Profession')}</InputLabel>
                    <Select
                      value={interactions.professionTypeId ? interactions.professionTypeId : ''}
                      onChange={(e) => this.handleChange('professionTypeId', e.target.value)}
                      inputProps={{
                        id: 'profession-label'
                      }}
                    >
                      {
                        professionTypeDropdown.map(m => <MenuItem key={m.value + 'prof'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                      }
                    </Select>
                  </FormControl> */}
                  </div>

                  <div className="mb-10">
                    <Checkbox
                      name="pregnancyAndBreastfeeding"
                      onChange={(e) => this.handleChange("pregnancyAndBreastfeeding", e.target['checked'])}
                      checked={!!interactions.pregnancyAndBreastfeeding}
                      value={interactions.pregnancyAndBreastfeeding + ""}
                      color="primary"
                    />
                    <label style={{ padding: '10px 0 0 0px' }}>
                      {Translate('Pregnancy and Breastfeeding')}
                    </label>
                  </div>
                </div>
              </AccordionTab>
            </Accordion>

          </> : null}

        <div style={{ padding: '10px 0', textAlign: 'right' }}>
          <Button variant="contained" size="medium" onClick={this.handleCancelClick} style={{ marginRight: '10px' }}>
            <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
            {Translate('Clear')}
          </Button>
          <Button variant="contained" size="medium" color='primary' onClick={this.handleCheckInteractions}
            disabled={interactions.medicines.length == 0}>
            <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
            {Translate('Check')}
          </Button>
        </div>
      </div>

    let resultHtml;

    switch (mode) {
      case 'interactionForm':
        resultHtml = interactionFormHtml;
        break;
      default:
        resultHtml = '';
    }

    return (
      <div className="app-content">

        {isLoading ? <Spinner /> : null}
        <Growl ref={(el) => this.growl = el} />

        <h2>{Translate('Interactions')}</h2>

        {resultHtml}

        {isVisibleInteractionsResults ?
          <InteractionsResultsComponent
            history={this.props.history}
            interactionsResult={interactionsResult}
            lang={this.props.lang}
          /> : null}

        {isVisibleSearchMedicineDialog ? (
          <MedicineSearchDialog
            isVisible={isVisibleSearchMedicineDialog}
            addMedicineClick={(medicine) => this.handleAddMedicineToList(medicine)}
            cancelClick={this.handleCancelSearchMedicine}
            dialogError={searchDialogError}
            clearDialogError={this.clearDialogError}
            lang={this.props.lang}
          />) : null
        }

      </div>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps)(InteractionsComponent);
